import React from "react";
import { Link } from "react-router-dom";  // Corrected import
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <p>&copy; 2024 GETFITFAST. All Rights Reserved.</p>
      <div className="footer-links">
        <div className="first-row">
          <Link to="/legal-links/privacy-policy">Privacy Policy</Link>
          <Link to="/legal-links/terms">Terms & Conditions</Link>
          <Link to="/legal-links/sitemap">Sitemap</Link>
        </div>
        <div className="second-row">
          <Link to="/legal-links/disclaimer">Disclaimer</Link>
          <Link to="/legal-links/contact">Contact Us</Link>
          <Link to="/legal-links/about">About Us</Link>
        </div>
      </div>
      <p>Email: getfitfast1901@gmail.com</p>
    </div>
  );
};

export default Footer;
